import camelCaseKeys from 'camelcase-keys';
import {
  ConnectedIntegration,
  HarvestIntegration,
  WebIntegration
} from '../../../../components/Integrations/types';
import { DashboardTask } from './queries';
import { DashboardProjectContext } from './projectContextQueries';

type Args = {
  task: DashboardTask;
  projectContext: DashboardProjectContext | null;
  currentUserId: string;
  bugherdUrl: string;
};

export const shouldShowIntegrationsTab = ({
  projectRole,
  connectedIntegrations,
  webIntegrations,
  harvestEnabled
}: {
  projectRole?: string | null;
  connectedIntegrations: unknown[];
  webIntegrations: unknown[];
  harvestEnabled: boolean;
}): boolean =>
  !!(
    projectRole !== 'guest' &&
    (connectedIntegrations.length || webIntegrations.length || harvestEnabled)
  );

export const useDrawerIntegrations = ({
  task,
  projectContext,
  currentUserId,
  bugherdUrl
}: Args) => {
  const projectId = Number(task.project.id);
  const organizationId = Number(task.project.organizationId);
  const localTaskId = Number(task.localTaskId);
  const projectName = projectContext?.name || '';
  const connectedIntegrations = (camelCaseKeys(
    projectContext?.connectedIntegrations || [],
    { deep: true }
  ) as unknown) as ConnectedIntegration[];
  const harvestIntegration = (projectContext?.harvestIntegration || {
    id: null
  }) as HarvestIntegration;
  const projectRole = projectContext?.users.find(
    user => String(user.id) === String(currentUserId)
  )?.role;
  const webIntegrations: WebIntegration[] = [];

  if (task.fullstorySessionUrl) {
    webIntegrations.push({
      key: 'fullStory',
      integration: {
        id: 'View session',
        url: task.fullstorySessionUrl
      }
    });
  }

  if (task.logrocketSessionUrl) {
    webIntegrations.push({
      key: 'logRocket',
      integration: {
        id: 'View session',
        url: task.logrocketSessionUrl
      }
    });
  }

  const harvestEmbedUrl = `https://platform.harvestapp.com/platform/timer?app_name=BugHerd&closable=false&chromeless=true&permalink=${bugherdUrl}/projects/${projectId}/tasks/${localTaskId}&external_item_id=${localTaskId}&external_item_name=${`Task ${localTaskId}`}&external_group_id=${projectId}&external_group_name=${projectName}`;

  return {
    showIntegrationsTab: shouldShowIntegrationsTab({
      projectRole,
      connectedIntegrations,
      webIntegrations,
      harvestEnabled: !!harvestIntegration?.id
    }),
    connectedIntegrations,
    harvestIntegration,
    harvestEmbedUrl,
    taskConnectionData: (camelCaseKeys(task.taskConnectionData || [], {
      deep: true
    }) as unknown) as {
      id: number;
      remoteTask: string;
      meta: Record<string, unknown>;
      projectIntegrationId: number;
    }[],
    webIntegrations,
    projectId,
    organizationId,
    taskId: Number(task.id),
    taskLocalId: localTaskId
  };
};
